module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/planning-and-optimization/assignments/assignments.component.css
// module id = ./src/app/components/planning-and-optimization/assignments/assignments.component.css
// module chunks = main